import { fetchProfileFieldsCompletenessApi } from 'api/profile/fetchProfileFieldsCompletenessApi'

export const FETCH_PROFILE_FIELDS_COMPLETENESS =
  'FETCH_PROFILE_FIELDS_COMPLETENESS' as const

export const fetchProfileFieldsCompletenessAction = () => ({
  type: FETCH_PROFILE_FIELDS_COMPLETENESS,
  promise: () => fetchProfileFieldsCompletenessApi(),
})

export const CLEAR_PROFILE_FIELDS_COMPLETENESS =
  'CLEAR_PROFILE_FIELDS_COMPLETENESS' as const

export const clearProfileFieldsCompletenessAction = () => ({
  type: CLEAR_PROFILE_FIELDS_COMPLETENESS,
})
